import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Chip, Stack } from '@mui/material';
import { useQuery } from '@apollo/client/react';
import gql from 'graphql-tag';
import Link from 'next/link';
import moment from 'moment';

const QUERY = gql`
  query petitesAnnonces($actorId: Int) {
    petitesAnnonces(actorId: $actorId, status: "active", onlyValidated: true) {
      id
      title
      shortDescription
      type
      city
      url
      createdAt
    }
  }
`;

interface Props {
  actorId: number | string;
}

const ActorPetitesAnnoncesSection: React.FC<Props> = ({ actorId }) => {
  const { data } = useQuery<any>(QUERY, { variables: { actorId: Number(actorId) }, skip: !actorId });
  const annonces = data?.petitesAnnonces || [];
  if (annonces.length === 0) return null;

  return (
    <Box sx={{ my: 5 }}>
      <Typography variant="h4" gutterBottom>Petites annonces de cet acteur</Typography>
      <Grid container spacing={2}>
        {annonces.map((a: any) => (
          <Grid item xs={12} sm={6} md={4} key={a.id}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardContent>
                <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                  <Chip
                    size="small"
                    label={a.type === 'offre' ? 'Offre' : 'Demande'}
                    color={a.type === 'offre' ? 'success' : 'warning'}
                  />
                </Stack>
                <Link href={`/petites-annonces/${a.url}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography variant="h6">{a.title}</Typography>
                </Link>
                <Typography variant="caption" color="text.secondary">
                  {moment(parseInt(String(a.createdAt))).fromNow()}
                  {a.city ? ` · ${a.city}` : ''}
                </Typography>
                {a.shortDescription && (
                  <Typography variant="body2" sx={{ mt: 1 }}>{a.shortDescription}</Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ActorPetitesAnnoncesSection;
